import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Favorite = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M19.0058 5.26265C19.4032 4.42385 20.5967 4.42384 20.9941 5.26265L25.1328 13.9999H34.7585C35.7385 13.9999 36.2293 15.1848 35.5363 15.8778L28.1122 23.3019L30.8989 33.9844C31.1572 34.9746 30.0421 35.7501 29.2037 35.1633L19.9999 28.7206L10.7961 35.1633C9.95785 35.7501 8.84266 34.9746 9.10096 33.9844L11.8877 23.3019L4.46355 15.8778C3.77058 15.1848 4.26137 13.9999 5.24137 13.9999H14.8671L19.0058 5.26265ZM20 7.83592L16.4308 15.3708C16.2488 15.755 15.8618 15.9999 15.4367 15.9999H7.41416L13.6665 22.2523C13.9426 22.5284 14.0516 22.9301 13.9531 23.3078L11.6539 32.1215L19.3691 26.7209C19.7479 26.4557 20.252 26.4557 20.6308 26.7209L28.346 32.1215L26.0468 23.3078C25.9482 22.9301 26.0573 22.5284 26.3334 22.2523L32.5857 15.9999H24.5632C24.1381 15.9999 23.7511 15.755 23.5691 15.3708L20 7.83592Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Favorite;
